import { render, staticRenderFns } from "./bind_part_dialog.vue?vue&type=template&id=c20fbe54&scoped=true"
import script from "./bind_part_dialog.vue?vue&type=script&lang=js"
export * from "./bind_part_dialog.vue?vue&type=script&lang=js"
import style0 from "./bind_part_dialog.vue?vue&type=style&index=0&id=c20fbe54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20fbe54",
  null
  
)

export default component.exports